<template>
  <div class="main main--hasHeader main--hasFooter">
      <div class="customContainer">
        <h2 class="members__headline">ACCESS</h2>
        <p style="margin: 2rem;">
          {{ word_chg('access_info_001') }}<br>
          {{ word_chg('access_info_002') }}<br>
          {{ word_chg('access_info_003') }}
        </p>
        <div class="members-list">
          <div>
            <a href=""></a>
            <img src="@/assets/img/main/access_map_info.jpg" alt=""/>
          </div>
        </div>
        <!-- <div class="members-menu__list">
          <ul>
            <li>
              <a href="https://www1.ms-event.net/mgcweb/mgwfile/members_guide.pdf" target="_blank">
                {{ word_chg('メンバーズガイド') }}
              </a>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
</template>
<script>
// import { mapState } from 'vuex'
export default {
  name: 'UserAccessView',
  data: function () {
      return {}
  },
  components: {
  },
  methods: {
  },
  computed: {
    // customer: state => state.apidata.customer,
  },
  created () {
  },
  mounted: function(){
  },
}
</script>
